var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"radio-button-square",class:{'radio-button-square--active': _vm.model === _vm.value},attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }